import React from 'react';
import { Content } from 'components/content/Content';
import { ContentItem } from 'components/content/ContentItem';
import { Overlap } from 'components/overlap/Overlap';
import { OverlapItem } from 'components/overlap/OverlapItem';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  const image = { url: 'https://picsum.photos/id/942/560/640', width: 560, height: 640 };

  return (
    <>
      <Divider>Staggered Blocks - Second with two links</Divider>

      <Content isSlice>
        <ContentItem
          tagline="Tagline"
          title="Title"
          text={
            <div>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
                tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
                Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien
                enim, accumsan dictum blandit eu, dictum vel felis.
              </p>
            </div>
          }
          image={image}
          label="Link One"
          link={{ href: 'https://kodo.is' }}
          caption="Image caption/description"
        />
        <ContentItem
          tagline="Tagline"
          title="Title"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          label="Link one label"
          link={{ href: 'https://kodo.is' }}
          secondLabel="Link two label"
          secondLink={{ href: 'https://kodo.is' }}
          caption="Image caption/description"
        />
      </Content>

      <Divider>Staggered Blocks with first image on left</Divider>

      <Content isSlice>
        <ContentItem
          tagline="Tagline"
          title="Title"
          direction="Left"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
              tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
              Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien
              enim, accumsan dictum blandit eu, dictum vel felis.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <ContentItem
          tagline="Tagline"
          title="Title"
          direction="Left"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
      </Content>

      <Divider>Overlapping Staggered Blocks - First with two links</Divider>

      <Overlap isSlice>
        <OverlapItem
          tagline="Tagline"
          title="Title"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
              tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
              Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien
              enim, accumsan dictum blandit eu, dictum vel felis.
            </p>
          }
          image={image}
          label="Link one label"
          link={{ href: 'https://kodo.is' }}
          secondLabel="Link two label"
          secondLink={{ href: 'https://kodo.is' }}
        />
        <OverlapItem
          tagline="Tagline"
          title="Title"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <OverlapItem
          tagline="Tagline"
          title="Title"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
      </Overlap>

      <Divider>Overlapping Staggered Blocks with first image on left</Divider>

      <Overlap isSlice>
        <OverlapItem
          tagline="Tagline"
          title="Title"
          direction="Left"
          text={
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
              tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
              Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien
              enim, accumsan dictum blandit eu, dictum vel felis.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <OverlapItem
          tagline="Tagline"
          title="Title"
          direction="Left"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
        <OverlapItem
          tagline="Tagline"
          title="Title"
          direction="Left"
          text={
            <p>
              Ut at justo ornare augue auctor maximus. Donec cursus egestas nisl laoreet bibendum.
              Maecenas in nunc vitae neque sodales molestie. Phasellus euismod arcu quis pharetra
              condimentum. Aenean gravida magna ac quam accumsan sodales.
            </p>
          }
          image={image}
          link={{ href: 'https://kodo.is' }}
        />
      </Overlap>
    </>
  );
};
